import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.SAVED_TOURS}/${endpoint ? endpoint : ""}`

export const savedToursBrandingService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBrandingSettings: builder.query({
      query: (companyId) => ({
        url: buildUrl("branding"),
        method: "GET",
        params: companyId ? { company_id: companyId } : {},
      }),
      providesTags: [{ type: "SavedToursBrandingSettings", id: "CURRENT" }],
    }),
    updateBrandingSettings: builder.mutation({
      query: ({ companyId, ...body }) => ({
        url: buildUrl("branding"),
        method: "PATCH",
        params: companyId ? { company_id: companyId } : {},
        body,
      }),
      invalidatesTags: [{ type: "SavedToursBrandingSettings", id: "CURRENT" }],
    }),
    getBrandingCompanies: builder.query({
      query: () => ({
        url: buildUrl("branding/companies"),
        method: "GET",
      }),
    }),
  }),
})

export const {
  useGetBrandingSettingsQuery,
  useUpdateBrandingSettingsMutation,
  useGetBrandingCompaniesQuery,
} = savedToursBrandingService
